export const ScreenURL = {
  /** STRONG BOX LANDING */
  HOME: "/",
  SHARING: "/document-sharing",
  AUTHENTICATION: "/document-authentication",
  INSIGHT: "/document-insight",
  PRICING: "/pricing",
  CONTACT: "/contact",
} as const;
